module.exports = __webpack_public_path__ + "img/arrow-bottom.5fdf0ca6.svg";